import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {SessionService} from '../services/session/session.service';
import {SystemConfig} from '../config/system-config';

@Injectable()
export class BalanceService {


  constructor(private http: Http,
              public sessionService: SessionService) {
  }

  getBalance(): Observable<any> {
    let headers: Headers = new Headers();
    return this.http.get(SystemConfig.Endpoint.BALANCE, {
      headers: headers
    });
  }

  updateBalance() {
    if (this.sessionService.punter) {
      this.getBalance().subscribe((response: any) => this.handleBalanceResponse(response));
    }
  }

  handleBalanceResponse(response: Response) {
    if (this.sessionService.punter) {
      const balance = +response.json();
      this.sessionService.punter.balance = balance;
      if(window.parent) {
        window.parent.postMessage({balance: balance}, '*');
      }
    }
  }
}




// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/balance/balance.service.ts